import { InjectionToken, Provider } from '@angular/core';

import { APP_INPUT_ORIGIN, APP_SELECTOR } from '../app.config-constants';

const setupMfeOrigin = () =>
  document.querySelector(APP_SELECTOR)?.getAttribute(APP_INPUT_ORIGIN) ||
  window.origin;

export const APP_ORIGIN = new InjectionToken<string>('APP_ORIGIN');

export function provideOrigin() {
  const providers: Provider[] = [
    {
      provide: APP_ORIGIN,
      useFactory: () => setupMfeOrigin(),
    },
  ];
  return providers;
}
